module.exports = __webpack_public_path__ + "static/media/Googleplus.66f7c228.svg";